import * as React from 'react';
import styled from '@emotion/styled';
import { Theme } from '@marble/theme';

export interface ModalProps {}

export const Drop = styled('div')<{ theme: Theme }>(({ theme }) => ({
  background: `${theme.palette.main.secondary4}CC`,
  zIndex: theme.zIndex.modal,
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Content = styled('div')<{ theme: Theme }>(({ theme }) => ({
  padding: `${theme.gutters.base * 5}px ${theme.gutters.base * 4}px`,
  boxShadow: '0 4px 8px 0 rgba(46, 64, 86, 0.21)',
  borderRadius: theme.radius.modal,
  width: '100%',
  maxWidth: 400,
  backgroundColor: theme.palette.background.site,
  margin: '0 20px',
}));

export const ResponsiveContent = styled(Content)<{ theme: Theme }>(({ theme }) => ({
  [`@media (max-width: ${theme.breakpoints.lg}px)`]: {
    width: '100%',
    height: '100%',
  },
}));

export const Modal: React.FunctionComponent<ModalProps> = ({ children }) => {
  return (
    <Drop>
      <Content>{children}</Content>
    </Drop>
  );
};

export default Modal;
